/**
 * Element format constants
 */

/**
 * All possible teaser formats
 */
const TeaserFormat = {
    TEASER_LARGE: 'teaserLarge',
    TEASER_SMALL: 'teaserSmall',
    TEASER_FULL: 'teaserFull',
    TEASER_SERIES: 'teaserSeries',
    TEASER_TOP_LIST: 'teaserTopList'
};

/**
 * All possible action button formats
 */
const ButtonFormat = {
    BUTTON_ACTION_BUBBLE: 'buttonActionBubble',
    BUTTON_ACTION_INLINE: 'buttonActionInline',
    BUTTON_ACTION_SLIDESHOW: 'buttonActionSlideshow'
};

/**
 * All possible actionbubble types
 */
const ActionBubbleFormat = {
    ACTION_BUBBLE_TEASER: 'actionBubbleTeaser',
    ACTION_BUBBLE_ARTICLE: 'actionBubbleArticle'
};

/**
 * All possible Slideshow types
 */
const SlideshowFormat = {
    SLIDESHOW_INLINE: 'slideshowInline',
    SLIDESHOW_FULLSCREEN: 'slideshowFullscreen',
    SLIDESHOW_STANDALONE: 'slideshowStandalone'
};

/**
 * All possible navigation formats
 */
const NavigationItemFormat = {
    NAVIGATION_ITEM_CATEGORY: 'navigationItemCategory',
    NAVIGATION_ITEM_SUBCATEGORY: 'navigationItemSubcategory',
    NAVIGATION_ITEM_HIGHLIGHTS: 'navigationItemHighlights',
    NAVIGATION_ITEM_DROPDOWN: 'navigationItemDropdown'
};

/**
 * All possible Image formats
 */
const ImageFormat = {
    IMAGE_CONTAIN: 'contain',
    IMAGE_COVER: 'cover',
    IMAGE_SHARE: 'share'
};

/**
 * All possible Ad formats
 */
const AdFormat = {
    INSIDE_FULL_POS: 'insideFullPos',
    INSIDE_FULL_TOP: 'insideFullTop',
    INSIDE_FULL_BRANDDAY: 'insideFullBrandday',
    INSIDE_FULL_RECOMMENDER_POS: 'insideFullRecommenderPos',
    INSIDE_QUARTER_POS: 'insideQuarterPos',
    OUTSIDE_RIGHT: 'outsideRight',
    CONTENT_END: 'contentEnd'
};

/**
 * All possible color schemes
 */
const ColorScheme = {
    PRIMARY: 'primaryColorScheme',
    SECONDARY: 'secondaryColorScheme'
};

export {TeaserFormat, ButtonFormat, ActionBubbleFormat, SlideshowFormat, NavigationItemFormat, ImageFormat, AdFormat, ColorScheme};
